__turbopack_context__.v({
  "badge": "SimilarProducts-module__HO6vpW__badge",
  "card": "SimilarProducts-module__HO6vpW__card",
  "grid": "SimilarProducts-module__HO6vpW__grid",
  "header": "SimilarProducts-module__HO6vpW__header",
  "imageContainer": "SimilarProducts-module__HO6vpW__imageContainer",
  "info": "SimilarProducts-module__HO6vpW__info",
  "price": "SimilarProducts-module__HO6vpW__price",
  "productName": "SimilarProducts-module__HO6vpW__productName",
  "section": "SimilarProducts-module__HO6vpW__section",
  "specs": "SimilarProducts-module__HO6vpW__specs",
  "title": "SimilarProducts-module__HO6vpW__title",
  "viewAll": "SimilarProducts-module__HO6vpW__viewAll",
});
